import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type FieldRubricStore = {
  rubric: string | null;
  setRubric: (rubric: string | null) => void;
};

export const useFieldRubricStore = create<FieldRubricStore>()(
  devtools(
    (set, _get) => ({
      rubric: null,
      setRubric: (rubric: string | null) => {
        set({ rubric });
      },
    }),
    {
      name: 'chat-field-rubrics-store',
    },
  ),
);
